export const getCaptureClockMetadata = (date) => (
  date instanceof Date && !Number.isNaN(date.getTime()) ? {
    selectedTime: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  } : { selectedTime: '', timeZone: '' }
);

